<template>
  <a :href="url" rel="noreferrer" target="_blank">
    <div
      class="bg-grey-10 dark:bg-dark-bg hover:bg-grey-9 dark:hover:bg-dark-surface-2 transition-colors duration-200 h-full rounded-lg p-4 lg:p-8"
    >
      <div class="flex items-center mb-4">
        <div class="flex flex-1 content-start">
          <AppAppIcon
            :src="icon"
            :alt="title"
            :size="12"
          />
        </div>
        <div class="flex flex-1">
          <div
            :class="[
              modelValue
                ? 'bg-black text-white hover:bg-grey-2 active:bg-grey-3 transition-all'
                : 'bg-grey-9 dark:bg-dark-surface-2 text-black dark:text-dark-ink hover:bg-grey-8 dark:hover:bg-dark-border active:bg-grey-7 dark:active:bg-dark-border transition-all',
              'ml-auto rounded-full p-3 cursor-pointer',
            ]"
            @click.prevent="updateValue"
          >
            <mdicon aria-label="Pin App" :name="pinIcon" />
          </div>
        </div>
      </div>

      <div>
        <p class="text-base font-semibold mb-2">{{ title }}</p>
        <p class="text-base text-grey-11 dark:text-dark-ink-muted">{{ description }}</p>
      </div>
    </div>
  </a>
</template>

<script setup>
import { ref } from 'vue'
import AppAppIcon from '../icons/AppAppIcon.vue'

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  modelValue: {
    type: Boolean,
    default: false,
  },
  url: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
    required: true,
  },
})

const emit = defineEmits(['update:modelValue'])

const pinIcon = ref('pin-outline')

const updateValue = () => {
  emit('update:modelValue', !props.modelValue)
}
</script>
